import {
  ApiResponseError,
  ApiSessionTimeoutError,
  classifyApiError,
  unwrapResponseModel
} from '../api/responseModel';

export {
  ApiResponseError as MateriasApiError,
  ApiSessionTimeoutError as MateriasSessionTimeoutError,
  classifyApiError as classifyMateriasError,
  unwrapResponseModel
};

export function toCreateMateriaPayload({
  code,
  name,
  dictado,
  anioDictado,
  practica,
  carreraCod,
  formato
}) {
  return {
    MateriaCarreraCodigo: code,
    MateriaCarreraNombre: name,
    MateriaCarreraDictado: dictado,
    MateriaCarreraAnio: anioDictado,
    MateriaPractica: practica,
    CarreraCod: carreraCod,
    MateriaFormato: formato
  };
}

export function toUpdateMateriaPayload({
  id,
  code,
  name,
  dictado,
  anioDictado,
  practica,
  carreraCod,
  formato
}) {
  return {
    MateriaCarreraCod: id,
    MateriaCarreraCodigo: code,
    MateriaCarreraNombre: name,
    MateriaCarreraDictado: dictado,
    MateriaCarreraAnio: anioDictado,
    MateriaPractica: practica,
    CarreraCod: carreraCod,
    MateriaFormato: formato
  };
}

export function validateMateriaForm(fields, { requireFormato = false } = {}) {
  const base = Boolean(
    fields.code?.length > 0
    && fields.name?.length > 0
    && fields.anioDictado?.length > 0
    && fields.dictado?.length > 0
    && fields.practica?.length > 0
    && fields.carreraPresent
  );
  if (!requireFormato) {
    return base;
  }
  return base && fields.formato?.length > 0;
}
